import React, { useContext, useEffect, useState } from "react";
import ResponsivContent from "../../components/ResponsivContent";
import { Edit } from "@mui/icons-material";
import styles from "./styles.module.css";
import { Autocomplete, Button, Grid, TextField, styled } from "@mui/material";
import InputMask from "react-input-mask";
import BlueButton from "../../components/BlueButton";
import SendIcon from "@mui/icons-material/Send";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { LoginContext } from "../../config/Context/LoginContext";
import {
  buscarDadosPendentes,
  cadastrarHistorico,
  inserirSolicitacao,
} from "../../services/api-planejamento-tributario.service";
import { corrigirCadastro } from "../../services/api-upload.service";
import banksData from "../../services/banks.json";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import { useNavigate } from "react-router-dom";
import { enviarNotificacao } from "../../utils/webSocket.util";

const response = [
  { cod: "ANEXO-RG", descricao: "Nome do Titular" },
  { cod: "ANEXO-CPF", descricao: "WhatsApp do Titular" },
];

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const EditarDadosCandidato = () => {
  const [listaCampos, setListaCampos] = useState([]);
  const [files, setFiles] = useState([]);
  const [dataForm, setDataForm] = useState([]);
  const { dadosLogin } = useContext(LoginContext);
  const [justificativa, setJustificativa] = useState("");
  const [msg, setMsg] = useState("");
  const [openSnackSucesso, setOpenSnackSucesso] = useState(false);
  const [openSnackErro, setOpenSnackErro] = useState(false);
  const [responseDadosPendentes, setResponseDadosPendentes] = useState();
  const [nome, setNome] = useState("");
  const [idCliente, setIdCliente] = useState();
  const navigate = useNavigate();



  const pegarHeader = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const id = urlParams.get("idCliente");
    if (id) {
      setIdCliente(id);
    }
  };

  const handleCloseSnackSucesso = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackSucesso(false);
  };
  const handleCloseSnackErro = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackErro(false);
  };

  const getInfoCandidato = () => {
    const id = idCliente ? idCliente : dadosLogin.idUsuario;
    const tipoUsuario = idCliente ? "C" : dadosLogin.tipoCadastroPlanTribKey;

    return {
      id,
      tipoUsuario,
    };
  };

  const handleResponse = async () => {
    await pegarHeader();

    try {
      const infoCandidato = getInfoCandidato();

      const responseAPI = await buscarDadosPendentes(
        infoCandidato.tipoUsuario,
        infoCandidato.id
      );
      setNome(responseAPI.dadosPendentes.nome);
      setJustificativa(responseAPI.dadosPendentes.justificativa);
      handleCamposACorrigir(responseAPI.dadosPendentes.camposForm);
      setResponseDadosPendentes(responseAPI.dadosPendentes.camposForm);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    pegarHeader();
    handleResponse();
  }, [idCliente]);

  useEffect(() => {
    handleResponse();
  }, []);

  useEffect(() => {
    handleResponse();
  }, [files]);

  const bankNames = banksData
    .map((bank) => `${bank.code} - ${bank.name}`)
    .sort((a, b) => {
      const codeA = parseInt(a.split(" - ")[0]);
      const codeB = parseInt(b.split(" - ")[0]);
      return codeA - codeB;
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    let temCampoComum = false;
    let temAnexo = false;
    if (dataForm.length !== 0) {
      temCampoComum = true;
    }
    if (files.length !== 0) {
      temAnexo = true;
    }

    if (
      responseDadosPendentes.length ===
      (files !== 0 ? dataForm.concat(files) : dataForm).length
    ) {
      try {
        await handleSubmitCampos(temAnexo, temCampoComum);
      } catch (error) {
        setMsg(error.response.data.mensagem);
        setOpenSnackErro(true);
        return;
      }
    } else {
      setMsg("Um ou mais campos não foram preenchidos");
      setOpenSnackErro(true);
      return;
    }

    //  notificação
    let tipo = "";
    let idEdicao = "";
    if (idCliente) {
      tipo = "Cliente";
      idEdicao = idCliente;
    } else {
      dadosLogin.tipoCadastroPlanTribKey === "A"
        ? (tipo = "Associado")
        : (tipo = "Parceiro");
      idEdicao = dadosLogin.idUsuario;
    }
    try {
      await enviarNotificacao({
        titulo: `Cadastro corrigido!`,
        texto: `O cadastro de ${nome} foi corrigido!`,
        grupos: ["JURIDICO"],
        path: `/gestao/juridico?tipo=${tipo}&id=${idEdicao}`,
        tipo: "WARNING",
      });
      setMsg("Campos corrigidos com sucesso!");
      setOpenSnackSucesso(true);
      setTimeout(() => {
        navigate("/dashboard");
      }, 3000)

    } catch (error) {
      setMsg(error.response.data.mensagem);
      setOpenSnackErro(true);
      return;
    }
  };

  const handleSubmitCampos = async (temAnexo, temCampoComum) => {
    const fileFormData = new FormData();

    //#region ------- historico

    const documentos = files.map((doc) => ({
      cod: doc.key,
      value: doc.file,
    }));

    const dataObject = files !== 0 ? dataForm.concat(documentos) : dataForm;

    const filterDataChange = () => {
      if (responseDadosPendentes) {
        const filterData = responseDadosPendentes.filter((responseItem) => {
          return dataObject.some((formItem) =>
            formItem.cod.includes(responseItem.formCodigoCampo)
          );
        });

        return filterData;
      }
    };

    const bodyMount = async () => {
      const data = await filterDataChange();
      const dataBody = data.map((item) => ({
        campo: item.formDescricaoCampo,
        codCampo: item.formCodigoCampo,
      }));

      return dataBody;
    };

    const objContentHistory = { tipoHistorico: "Resposta", dados: await bodyMount() }

    //#endregion

    if (dataObject) {
      fileFormData.append(
        "tipoCadastro",
        idCliente ? "C" : dadosLogin.tipoCadastroPlanTribKey
      );
      fileFormData.append("idUsuario", idCliente ?? dadosLogin.idUsuario);
      fileFormData.append("contentHistorico", JSON.stringify(objContentHistory));
      fileFormData.append("temAnexo", temAnexo);
      if (temCampoComum) {
        fileFormData.append("campos", JSON.stringify(dataForm));
      }
      if (temAnexo) {

        files.forEach((item) => {
          fileFormData.append("files", item.file);
          fileFormData.append("cods", item.key);
        });
      }
    }

    try {
      await corrigirCadastro(fileFormData);

      return;
    } catch (error) {
      throw error;
    }
  };

  const handleFileChange = (e) => {
    const { files: file, name: key } = e.target;
    setFiles((prevFiles) => {
      const novaLista = prevFiles.filter((item) => item.key !== key);
      novaLista.push({ file: file[0], key });
      return novaLista;
    });
  };

  const handleChange = (e) => {
    const { name } = e.target;
    const value = e.target.value.replace(/[^\w\s]/gi, "");

    setDataForm((prevDataForm) => {
      const novaLista = prevDataForm.filter((item) => item.cod !== name);
      if (value) {
        novaLista.push({ cod: name, value });
      }
      return novaLista;
    });
  };

  const handleChangeAutoComplete = (name, value) => {
    setDataForm((prevDataForm) => {
      const novaLista = prevDataForm.filter((item) => item.cod !== name);

      if (value) {
        novaLista.push({ cod: name, value });
      }

      return novaLista;
    });
  };

  const handleCamposACorrigir = (lista) => {
    const campos = [];
    lista.forEach((campo) => {
      switch (true) {
        case campo.formCodigoCampo.includes("ANEXO"):
          {
            const componente = (
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  label={campo.formDescricaoCampo}
                  fullWidth
                  value={
                    files.find((item) => item.key === campo.formCodigoCampo)
                      ?.file.name
                  }
                  InputProps={{ endAdornment: null }}
                  required
                  disabled
                />

                <Button
                  component="label"
                  variant="contained"
                  size="small"
                  id="btnUploadCartaoCnpj"
                  onChange={handleFileChange}
                >
                  <UploadFileIcon />
                  <VisuallyHiddenInput
                    type="file"
                    name={campo.formCodigoCampo}
                  />
                </Button>
              </div>
            );

            campos.push(componente);
          }
          break;
        case campo.formCodigoCampo.includes("CPF"):
          {
            const componente = (
              <InputMask
                mask={"999.999.999-99"}
                maskChar={null}
                name={campo.formCodigoCampo}
                onChange={handleChange}
                value={
                  dataForm.find((item) => item.cod === campo.formCodigoCampo)
                    ?.value
                }
              >
                {() => (
                  <TextField
                    size="small"
                    label={campo.formDescricaoCampo}
                    name={campo.formCodigoCampo}
                    fullWidth
                    required
                  />
                )}
              </InputMask>
            );

            campos.push(componente);
          }
          break;
        case campo.formCodigoCampo.includes("BANCO"):
          {
            const componente = (
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={bankNames}
                name={campo.formCodigoCampo}
                fullWidth
                size="small"
                onChange={(_, value) =>
                  handleChangeAutoComplete(campo.formCodigoCampo, value)
                }
                renderInput={(params) => (
                  <TextField {...params} label="Bancos" />
                )}
              />
            );

            campos.push(componente);
          }
          break;
        case campo.formCodigoCampo.includes("TELEFONE"):
          {
            const componente = (
              <InputMask
                mask={"(99) 9999-9999"}
                maskChar={null}
                name={campo.formCodigoCampo}
                onChange={handleChange}
                value={
                  dataForm.find((item) => item.cod === campo.formCodigoCampo)
                    ?.value
                }
              >
                {() => (
                  <TextField
                    size="small"
                    label={campo.formDescricaoCampo}
                    name={campo.formCodigoCampo}
                    fullWidth
                    required
                  />
                )}
              </InputMask>
            );

            campos.push(componente);
          }
          break;
        case campo.formCodigoCampo.includes("WHATSAPP"):
          {
            const componente = (
              <InputMask
                mask={"(99) 99999-9999"}
                maskChar={null}
                name={campo.formCodigoCampo}
                onChange={handleChange}
                value={
                  dataForm.find((item) => item.cod === campo.formCodigoCampo)
                    ?.value
                }
              >
                {() => (
                  <TextField
                    size="small"
                    label={campo.formDescricaoCampo}
                    name={campo.formCodigoCampo}
                    fullWidth
                    required
                  />
                )}
              </InputMask>
            );

            campos.push(componente);
          }
          break;
        case campo.formCodigoCampo.includes("EMAIL"):
          {
            const componente = (
              <TextField
                size="small"
                type="email"
                label={campo.formDescricaoCampo}
                name={campo.formCodigoCampo}
                onChange={handleChange}
                value={
                  dataForm.find((item) => item.cod === campo.formCodigoCampo)
                    ?.value
                }
                fullWidth
                required
              />
            );

            campos.push(componente);
          }
          break;
        default:
          {
            const componente = (
              <TextField
                size="small"
                label={campo.formDescricaoCampo}
                name={campo.formCodigoCampo}
                onChange={handleChange}
                value={
                  dataForm.find((item) => item.cod === campo.formCodigoCampo)
                    ?.value
                }
                fullWidth
                required
              />
            );

            campos.push(componente);
          }
          break;
      }
    });
    setListaCampos(campos);
  };

  return (
    <section className={styles.container}>
      <ResponsivContent maxWidth={"70%"}>
        {listaCampos.length !== 0 ? (
          <>
            <div className={styles.header__responsivContent}>
              <Edit className={styles.icon__header} />
              <h1 className={styles.title__header}>Edite seus dados</h1>
            </div>
            <div className={styles.content__responsivContent}>
              <h2 className={styles.title__content}>
                Preencha novamente os campos abaixo com as informações corretas
                para darmos prosseguimento no cadastro.
              </h2>
              <p className={styles.text__content}>{justificativa}</p>
            </div>
            {/* Renderização dos campos para ajustar */}
            <form onSubmit={handleSubmit} className={styles.form}>
              <Grid container spacing={2} className={styles.container__campos}>
                {listaCampos.map((item, i) => {
                  return (
                    <Grid key={i} item xs={12} sm={12} md={6}>
                      {item}
                    </Grid>
                  );
                })}
              </Grid>
              <div className={styles.container__buttons}>
                <BlueButton
                  contentIcon={<SendIcon />}
                  textValue="Prosseguir"
                  type="submit"
                />
              </div>
            </form>
          </>
        ) : (
          <h2 className={styles.title__content}>
            Sem campos para serem corrigidos.
          </h2>
        )}
      </ResponsivContent>
      <MensagemSucesso
        open={openSnackSucesso}
        msg={msg}
        handleClose={handleCloseSnackSucesso}
      />
      <MensagemErro
        open={openSnackErro}
        msg={msg}
        handleClose={handleCloseSnackErro}
      />
    </section>
  );
};

export default EditarDadosCandidato;
